import { Panel } from '../../../common/panel'
import { FilterList } from './FilterList'
import { TableComponent } from './TableComponent'
import './i18n'

export const PackageSubscriptionManagement = () => {
  return (
    <Panel label="userManagement.packageSubManagement.TITLE" isI18n>
      <FilterList />
      <TableComponent />
    </Panel>
  )
}
